import {useLazyQuery} from '@apollo/client';
import {useNavigate} from 'react-router-dom';
import {OV_BUILDER_DETAILS} from '../BuilderGrid/builderOvPotQueries';
import {
  OvbuilderDetails,
  OvbuilderDetailsVariables,
} from '../../../schema-types/OvbuilderDetails';

export function useOVBuilderDetails() {
  const navigate = useNavigate();
  const [queryGetOVBuilderDetails, {data, error, loading}] = useLazyQuery<
    OvbuilderDetails,
    OvbuilderDetailsVariables
  >(OV_BUILDER_DETAILS);

  return {
    queryGetOVBuilderDetails,
    ovBuilderData: data?.ovrecommendDetails,
    loadingOvBuilder: loading,
  };
}
